import { List } from "@singularsystems/neo-core";
import TotalHoldingsLookup from "../../../Home/Models/Lookups/TotalHoldingsLookup";
import React from "react";
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official'


export function TotalHoldingsPieChart(props: {dataList: List<TotalHoldingsLookup>})
{
    if(props.dataList.length<2){
        return (
            <div>
                <h1>Not Enough Data</h1>
            </div>
        );
    }
    return (
        <div className="col-lg-12 col-xl-12 col-md-9 col-sm-10 p-0 m-0">
            <HighchartsReact
                highcharts={Highcharts}
                options={getTotalHoldingsChart(props.dataList) as Highcharts.Options} 
            />
        </div>
    );
}

function getTotalHoldingsChart(data: List<TotalHoldingsLookup>)
{
    var dataObject: {name: string; y: number;}[] = [];
    var labelFormatString = ' {name} - $ {y:,.0f} '

    data.forEach(x => {
        dataObject.push({name: x.brokerName, y: x.total});
    });

    return {
        chart: {
            type: "pie",
            plotBorderWidth: 2
        },
        title: {
            text: "<b>Total USD per Broker as per the Latest Book Value Holding Date</b>",
            align: 'center'
        },
        accessibility: {
            point: {
                valueSuffix: 'USD'
            }
        },
        plotOptions: {
            pie: {
                allowPointSelect: true,
                cursor: 'pointer',
                dataLabels: {
                    enabled: true,
                    format: '{point.percentage:.1f}%',
                    position: 'center',
                    distance: '-20%'
                },
                showInLegend: true,
            }
        },
        legend: {
            title: {
              text: 'Brokers'
          },
          borderWidth: 2,
          align: 'right',
          layout: 'vertical',
          itemMarginTop: 10,
          labelFormat: labelFormatString
        },
        series: [{
            animation: true,
            type: "pie", 
            name: "Total Value (USD)",
            data: dataObject,  
        }],
    } 
}
